var render = function render(){var _vm=this,_c=_vm._self._c;return _c(this.$route.name === 'login' || this.$route.path === '/'
      ? 'layout-blank'
      : this.$route.name === 'prop' ? 'layout-info'
      : 'layout-content',{tag:"component"},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }